import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="w-full bg-gray-900 text-gray-300 py-12 px-6" data-id="element-25">
      <div className="max-w-6xl mx-auto" data-id="element-26">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-27">
          <div data-id="element-28">
            <h3 className="text-white text-lg font-semibold mb-4" data-id="element-29">
              About SoftwarePair
            </h3>
            <p className="text-sm leading-relaxed" data-id="element-30">
              Your trusted source for software reviews, cybersecurity insights,
              and technology guides since 2009. Visit{' '}
              <a href="https://softwarepair.com/" rel="dofollow" className="text-blue-400 hover:text-blue-300 underline" data-id="element-31">
                softwarepair.com
              </a>{' '}
              for expert recommendations.
            </p>
          </div>
          <div data-id="element-32">
            <h3 className="text-white text-lg font-semibold mb-4" data-id="element-33">
              Topics We Cover
            </h3>
            <ul className="text-sm space-y-2" data-id="element-34">
              <li data-id="element-35">Cybersecurity & Privacy</li>
              <li data-id="element-36">Software Reviews</li>
              <li data-id="element-37">Cloud Computing</li>
              <li data-id="element-38">Artificial Intelligence</li>
              <li data-id="element-39">Business Software</li>
              <li data-id="element-40">VPN & Security Tools</li>
            </ul>
          </div>
          <div data-id="element-41">
            <h3 className="text-white text-lg font-semibold mb-4" data-id="element-42">Contact</h3>
            <p className="text-sm mb-2" data-id="element-43">
              Email:{' '}
              <a href="mailto:hello@softwarepair.com" className="text-blue-400 hover:text-blue-300" data-id="element-44">
                hello@softwarepair.com
              </a>
            </p>
            <p className="text-sm" data-id="element-45">
              Website:{' '}
              <a href="https://softwarepair.com/" rel="dofollow" className="text-blue-400 hover:text-blue-300 underline" data-id="element-46">
                softwarepair.com
              </a>
            </p>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center" data-id="element-47">
          <p className="text-sm" data-id="element-48">
            © {currentYear} SoftwarePair.com. All rights reserved. | Making
            technology safer, smarter, and easier for everyone.
          </p>
          <p className="text-xs mt-2 text-gray-400" data-id="element-49">
            This page is optimized for search engines and designed to be fully
            crawlable by Google and other search engines.
          </p>
        </div>
      </div>
    </footer>;
}